<template>
  <div>
    <el-row :gutter="10"
            style="padding-bottom:10px">

      <el-col :span="6">
        <el-button type="primary"
                   @click="add">新增</el-button>
      </el-col>
    </el-row>
    <Table ref="TablesRef"
           :tableData="tableData" />
    <Form ref="FormRef" />
    <pagination ref="pagination"
                :get-data="initData"
                :now-page.sync="page"
                :now-size.sync="size"
                :total="totalElements" />
  </div>
</template>

<script>
import Form from './components/form.vue'
export default {
  data () {
    return {
      page: 1,
      size: 10,
      totalElements: 0,
      tableData: [],
      pageName: 'cz_teachingMaterials_round_admin',
      tableColumns: [
        { prop: 'lecture_turn_id', align: 'center', label: '编号', width: '100', showToopic: false },
        { prop: 'lecture_turn_name', align: 'center', label: '轮次名称', width: '200', showToopic: true },
        { prop: 'grade_name', align: 'center', label: '年级', width: '200', showToopic: true },
        { prop: 'lecture_turn_description', align: 'center', label: '轮次描述', width: '', showToopic: false },
        {
          prop: 'd', align: 'center', label: '操作', width: '200', type: 'img', btns: [
            { content: '修改', type: 'edit', event: 'edit' },
            { content: '删除', type: 'del', event: 'delRow' },
          ]
        },
      ]
    }
  },
  components: {
    Form
  },
  mounted () {
    this.setTablesColums()
  },
  methods: {
    setTablesColums () {
      this.$refs.TablesRef.pageName = this.pageName
      this.$refs.TablesRef.setColumns(this.tableColumns)
    },
    initData (page, limit) {
      this.tableLoading = true
      this.$http({
        url: '/api/v1/lecture/turn',
        method: 'get',
        params: {
          page,
          limit,
          grade_id: this.grade_id,
        }
      }).then(res => {
        this.tableData = res.data.list
        this.totalElements = res.data.count
      })
    },
    delRow (row) {
      this.$confirm("此操作将删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http({
          url: '/api/v1/lecture/del_turn',
          method: 'post',
          data: {
            lecture_turn_id: row.lecture_turn_id
          }
        })
      }).then(() => {
        this.$notify({
          title: '提示',
          message: '成功!',
          type: 'success'
        });
        setTimeout(() => {
          this.search()
        }, 500);
      })
    },
    edit (row) {
      let form = JSON.parse(JSON.stringify(row))
      this.$refs.FormRef.text = '修改'
      this.$refs.FormRef.form = form
      this.$refs.FormRef.dialogVisible = true
    },
    // 刷新
    refresh () {
      this.$refs.pagination.shuaxin()
    },
    // 查询
    search () {
      this.$refs.pagination.toFirstPage()
    },
    add () {
      let form = {
        lecture_turn_name: '',
        lecture_grade: '',
        lecture_turn_description: ''
      }
      this.$refs.FormRef.text = '新增'
      this.$refs.FormRef.form = form
      this.$refs.FormRef.dialogVisible = true

    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__footer {
  text-align: center;
}
</style>
